import { hasUnicode } from './hasUnicode';
import { unicodeToArray } from './unicodeToArray';
/**
 * Разбивает переданную строку в массив посимвольно.
 * Функция нужна для строк с юникодными символами, с которым стандартный string.split('') работает некорректно.
 *
 * @param string Строка
 * @returns Массив символов
 *
 * @example
 * ```typescript
 * import { stringToArray } from '@direct-frontend/stdlib';
 *
 * stringToArray('b\ud800l\u200d'); // ['b', '\ud800', 'l', '\u200d']
 * ```
 */
export function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : string.split('');
}
